import { AuthorizedProjectView36p4bgamz7ogy as AuthorizedProjectView } from '../common/AuthorizedProjectView.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../common/ProjectView.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ContractorProjectClass;
function ContractorProject() {
  if (ContractorProjectClass === VOID) {
    class $ extends AuthorizedProjectView() {
      constructor(projectId) {
        super(ProjectLens_Contractor_getInstance(), projectId);
      }
      dev() {
        return this.ogj_1;
      }
    }
    initMetadataForClass($, 'ContractorProject', VOID, VOID, VOID, [1]);
    ContractorProjectClass = $;
  }
  return ContractorProjectClass;
}
//region block: exports
export {
  ContractorProject as ContractorProject2o386x7rid4t,
};
//endregion

//# sourceMappingURL=ContractorProject.mjs.map
